import { Input } from 'antd';
import type { QuestionItem, AnswerValue, TextareaConfig } from '@/types/questionnaire';

const { TextArea } = Input;

interface TextareaQuestionProps {
  question: QuestionItem;
  value?: AnswerValue;
  readOnly?: boolean;
  onChange?: (value: AnswerValue) => void;
}

const TextareaQuestion = ({ question, value, readOnly = false, onChange }: TextareaQuestionProps) => {
  const config = question.config as TextareaConfig;
  const {
    maxLength,
    minLength,
    placeholder,
    rows = 4,
    showCount = true,
  } = config;

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  // 只读模式：显示文本内容
  if (readOnly) {
    const textValue = typeof value === 'string' ? value : '';
    if (!textValue) {
      return <span className="text-slate-400">未填写</span>;
    }
    return (
      <div className="text-slate-700 whitespace-pre-wrap leading-relaxed p-3 bg-slate-50 rounded border border-slate-200">
        {textValue}
      </div>
    );
  }

  // 编辑模式：渲染文本域
  return (
    <TextArea
      value={typeof value === 'string' ? value : ''}
      placeholder={placeholder || '请输入...'}
      rows={rows}
      maxLength={maxLength}
      showCount={showCount}
      onChange={handleChange}
      className="w-full"
    />
  );
};

export default TextareaQuestion;
